import { base, sepolia } from "wagmi/chains";

export const PAYMENT_API_PATH = "/api/payments";
export const BLOCK_EXPLORER_URL = process.env.NEXT_PUBLIC_BLOCK_EXPLORER_URL;
export const KOLZ_TOKEN_ADDRESS = process.env.NEXT_PUBLIC_KOLZ_TOKEN_ADDRESS as `0x${string}`;
export const ETH_AMOUNT = process.env.NEXT_PUBLIC_ETH_AMOUNT || "0.0000001";
export const TREASURY_ADDRESS = process.env.NEXT_PUBLIC_TREASURY_ADDRESS as `0x${string}`;
export const IS_MAINNET = process.env.NEXT_PUBLIC_IS_MAINNET === "true";
export const CHAIN = IS_MAINNET ? base : sepolia;
export const CHAIN_ID = CHAIN.id;
export const UNISWAP_API_PATH = "/api/uniswap";
export const UNISWAP_POOL_URL = "https://app.uniswap.org/explore/pools/base";
export const DEFAULT_RANDOM_TWEET_PROMPT =
  "You're a social media manager. Create a random tweet based on your knowledge, be creative and don't repeat topics. Make it engaging and authentic to your personality.";
export const DEFAULT_RANDOM_LINKEDIN_PROMPT =
  "You're a professional social media manager for LinkedIn. Create a thoughtful, professional post that would be appropriate for LinkedIn. Focus on industry insights, professional development, business trends, or thought leadership. Make it engaging and authentic to your professional personality. Keep it conversational but professional.";
